/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Fraction } from './Fraction';
const PatchSubmissionRubricDataItemParser = 
/* #__PURE__ */ parsers.object([
    ['rowId', codecNumber, 'row_id'],
    ['lockId', codecString, 'lock_id'],
    ['percentage', Fraction],
    [
        'gradeCalculation',
        /* #__PURE__ */ parsers.exactly('full', 'partial'),
        'grade_calculation',
    ],
]);
export class PatchSubmissionRubricDataItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSubmissionRubricDataItemParser.decode(input).map(res => new PatchSubmissionRubricDataItem(res));
    }
    static unsafeDecode(input) {
        return PatchSubmissionRubricDataItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSubmissionRubricDataItemParser.encode(data);
    }
    static schema() {
        return PatchSubmissionRubricDataItemParser.schema();
    }
}
